import React from 'react';
import Section from '../partials/Section';
import { createUseStyles } from 'react-jss';

interface RoleDetailsProps {
  roleName: string;
  roleDescription?: string;
  onMissionAndRoleDetailsClick: () => void;
}

const useStyles = createUseStyles({
  button: {
    background: 'none',
    border: 'none',
    color: '#7000E3',
    fontSize: '16px',
    fontWeight: 500,
    cursor: 'pointer',
    padding: '8px 0',
    textDecoration: 'none',
    display: 'inline-block',
    marginTop: '16px',
  },
  divider: {
    backgroundColor: '#DADADC',
    height: '1px',
    margin: '80px 0',
  },
});

export default function RoleDetails({
  roleName,
  roleDescription,
  onMissionAndRoleDetailsClick,
}: RoleDetailsProps) {
  const styles = useStyles();
  return (
    <Section type={'large'} title={`${roleName} role description`}>
      <div>
        <div>{roleDescription}</div>
        <button
          onClick={onMissionAndRoleDetailsClick}
          className={styles.button}
        >
          Mission and Role details →
        </button>
        <div className={styles.divider} />
      </div>
    </Section>
  );
}
